import { useEffect, type FC } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyCommitted } from '@/services/navProgress';

/**
 * Маячок готовности роута. Монтируется внутри Suspense конкретного маршрута,
 * поэтому его эффект срабатывает только когда страница реально отрисована (чанк
 * загружен). Сообщает стору фактически отрисованный путь. Ничего не рендерит.
 */
export const RouteProgressBeacon: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    notifyCommitted(pathname);
  }, [pathname]);

  return null;
};
